import { centsToDollars, centsToDollarsFormatted } from '@lib/conversions'
import {
  isWeeklyRecurringPayment,
  isMonthlyRecurringPayment,
  isRecurringPayment,
} from '@utils/groupEventUtils'

export const formatBookCardPrice = (priceInCents) => {
  if (priceInCents == null) return ''
  const dollars = centsToDollars(priceInCents)
  if (dollars == null) return ''
  if (dollars % 1 === 0) {
    return `$${Number(dollars).toLocaleString('en-US', { maximumFractionDigits: 0 })}`
  }
  return centsToDollarsFormatted(priceInCents)
}

export const getBookCardPriceSuffix = (event) => {
  if (isWeeklyRecurringPayment(event)) return '/ week / participant'
  if (isMonthlyRecurringPayment(event)) return '/ month / participant'
  if (isRecurringPayment(event)) return '/ participant'
  return 'per student'
}
